import { useQuery } from 'react-query'
import apiService from '../services/api'
import { useEffect, useState } from 'react'
import { Search, Users } from 'lucide-react'
import AdminLayout from '../components/AdminLayout'

const AdminUsers = () => {
  const [search, setSearch] = useState('')
  const { data, refetch, isLoading } = useQuery(
    ['admin-users', search],
    () => apiService.get('/users', { params: { search } }).then(r => r.data),
    { keepPreviousData: true }
  )

  useEffect(() => {
    const t = setTimeout(() => refetch(), 300)
    return () => clearTimeout(t)
  }, [search, refetch])

  const users = data?.users || []

  return (
    <AdminLayout title="Administration" subtitle="Utilisateurs">
        <div className="card mb-6">
          <div className="flex items-center">
            <Search className="h-4 w-4 text-gray-500 mr-2" />
            <input
              className="input-field"
              placeholder="Rechercher nom, prénom, société, email"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="card">
          <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center">
              <Users className="h-5 w-5 mr-2 text-orange-500" />
              Utilisateurs ({users.length})
            </h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 font-semibold text-gray-700">Nom</th>
                  <th className="text-left py-3 px-4 font-semibold text-gray-700">Prénom</th>
                  <th className="text-left py-3 px-4 font-semibold text-gray-700">Société</th>
                  <th className="text-left py-3 px-4 font-semibold text-gray-700">Téléphone</th>
                  <th className="text-left py-3 px-4 font-semibold text-gray-700">Email</th>
                  <th className="text-left py-3 px-4 font-semibold text-gray-700">Rôle</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="6" className="py-12 text-center text-gray-600">Chargement…</td>
                  </tr>
                ) : users.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="py-12 text-center text-gray-600">Aucun utilisateur</td>
                  </tr>
                ) : (
                  users.map(u => (
                    <tr key={u.id} className="border-b border-gray-200 hover:bg-gray-50">
                      <td className="py-3 px-4">{u.last_name || '-'}</td>
                      <td className="py-3 px-4">{u.first_name || '-'}</td>
                      <td className="py-3 px-4">{u.company_name || '-'}</td>
                      <td className="py-3 px-4">{u.phone || '-'}</td>
                      <td className="py-3 px-4">{u.email}</td>
                      <td className="py-3 px-4 capitalize">{u.role}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
    </AdminLayout>
  )
}

export default AdminUsers
